import { useCallback, useEffect, useRef } from 'react';

// Usage delivery can finish after the reply. Refresh only balances, without
// reloading feature gates or reconnecting the chat socket.
export default function useCreditRefreshAfterChat(companyId, refreshCredits) {
    const refreshRef = useRef(refreshCredits);
    const timers = useRef([]);
    refreshRef.current = refreshCredits;
    const clear = useCallback(() => {
        timers.current.forEach(clearTimeout);
        timers.current = [];
    }, []);
    useEffect(() => {
        const onFocus = () => refreshRef.current();
        window.addEventListener('focus', onFocus);
        return () => { clear(); window.removeEventListener('focus', onFocus); };
    }, [companyId, clear]);
    return useCallback(() => {
        clear();
        refreshRef.current();
        timers.current = [2000, 10000, 30000].map(delay => setTimeout(() => refreshRef.current(), delay));
    }, [companyId, clear]);
}
